export default __webpack_public_path__ + "4a60a7bd946d2c5e2be63763442802da.twig";